// Traduções adicionais das páginas do cliente (mescladas em translations.js)
export const extra = {
  pt: {
    "trade.close": "Fechar",
    "docs.type": "Tipo de documento",
    "docs.kind.id_card": "Documento de identidade (ID)",
    "docs.kind.passport": "Passaporte",
    "docs.kind.address_proof": "Comprovativo de residência",
    "docs.kind.other": "Outro",
    "docs.limit": "PDF, PNG ou JPG · máximo 5 MB",
    "docs.tooLarge": "O ficheiro excede o limite de 5 MB",
    "docs.pickFirst": "Escolha um documento primeiro",
    "docs.sent": "Documento enviado — em análise",
    "docs.mine": "Os meus documentos",
    "docs.empty": "Ainda não enviou documentos",
    "auth.overline": "Acesso à plataforma",
    "auth.loginTitle": "Entrar na sua conta",
    "auth.loginSubtitle": "Mercados globais num só terminal.",
    "auth.email": "Email",
    "auth.password": "Palavra-passe",
    "auth.phone": "Telefone",
    "auth.signIn": "Entrar",
    "auth.createAccount": "Criar conta",
    "auth.registerOverline": "Novo utilizador",
    "auth.registerTitle": "Criar conta",
    "auth.registerSubtitle": "Registo apenas com código de acesso.",
    "auth.name": "Nome",
    "auth.namePlaceholder": "O seu nome",
    "auth.newPassword": "Criar palavra-passe",
    "auth.passwordHint": "Mínimo 6 caracteres",
    "auth.inviteCode": "Código de registo",
    "auth.haveAccount": "Já tem conta?",
    "auth.twofaOverline": "Verificação em dois passos",
    "auth.twofaTitle": "Código de autenticação",
    "auth.twofaSubtitle": "Introduza o código de 6 dígitos da sua aplicação autenticadora.",
    "auth.verify": "Verificar",
    "auth.useRecovery": "Usar código de recuperação",
    "auth.useAuthenticator": "Usar código do autenticador",
    "auth.recoveryCode": "Código de recuperação",
    "auth.setupOverline": "Segurança obrigatória",
    "auth.setupTitle": "Ativar 2FA",
    "auth.setupSubtitle": "Contas administrativas exigem autenticação em dois fatores.",
    "auth.tagline": "Trading para quem exige mais",
    "auth.taglineSub": "Mercados globais. Ferramentas profissionais",
    "auth.footer": "Cinco mercados · Execução instantânea",
    "pager.prev": "Anterior",
    "pager.next": "Seguinte",
    "pager.page": "Página",
    "pager.records": "registo(s)",
    "profile.personalInfo": "Informações pessoais",
    "profile.firstName": "Primeiro nome",
    "profile.lastName": "Sobrenome",
    "profile.country": "País de Residência",
    "profile.city": "Cidade",
    "profile.street": "Rua",
    "profile.postalCode": "Código postal",
    "funds.balance": "Saldo da conta",
    "funds.free": "Margem livre",
    "funds.used": "Margem usada",
    "funds.deposit": "Depósito",
    "funds.depositDesc": "Transferências para a sua conta por BTC, USDT ou PIX.",
    "funds.withdraw": "Retirar",
    "funds.withdrawDesc": "Peça uma retirada para a conta que registou.",
    "deposit.title": "Depósito",
    "deposit.none": "Nenhum método disponível. Contacte o suporte.",
    "deposit.pixKey": "Chave PIX",
    "deposit.wallet": "Carteira",
    "deposit.amount": "Montante (USD)",
    "deposit.reference": "Referência / hash da transferência (opcional)",
    "deposit.confirm": "Confirmar depósito",
    "deposit.history": "Histórico de depósitos",
    "deposit.empty": "Sem depósitos",
    "deposit.copied": "Copiado",
    "deposit.registered": "Depósito registado — em análise",
    "status.pending": "em análise",
    "status.approved": "aprovado",
    "status.rejected": "recusado",
    "withdraw.accountName": "Nome (ex: Minha carteira)",
    "withdraw.bank": "Banco / BIC-SWIFT (opcional)",
    "withdraw.empty": "Sem pedidos",
    "withdraw.sent": "Pedido enviado — em análise",
    "withdraw.accountAdded": "Conta de recebimento adicionada",
    "calendar.title": "Calendário Económico",
    "calendar.subtitle": "Eventos macroeconómicos e notícias em tempo real dos mercados.",
    "calendar.events": "Calendário",
    "calendar.news": "Notícias",
    "tools.title": "Ferramentas de análise de mercado",
    "tools.subtitle": "Indicadores técnicos, visão geral, rastreador e mapa de calor.",
    "tools.symbols": "Mercados mundiais",
    "tools.overview": "Visão de mercado",
    "tools.screener": "Rastreador",
    "tools.heatmap": "Mapa de calor",
    "settings.subtitle": "Atualize os seus dados de perfil e a sua palavra-passe.",
    "settings.profile": "Perfil",
    "settings.name": "Nome",
    "settings.email": "Email",
    "settings.phone": "Telefone",
    "settings.saveProfile": "Guardar perfil",
    "settings.security": "Segurança",
    "settings.currentPwd": "Palavra-passe atual",
    "settings.newPwd": "Nova palavra-passe",
    "settings.confirmPwd": "Confirmar",
    "settings.changePwd": "Alterar palavra-passe",
    "settings.profileUpdated": "Perfil atualizado",
    "settings.pwdChanged": "Palavra-passe alterada",
    "settings.pwdMismatch": "As palavras-passe novas não coincidem",
    "dash.hello": "Olá",
    "dash.subtitle": "Visão geral da sua conta",
    "dash.balance": "Saldo",
    "dash.invested": "Investido",
    "dash.positions": "Posições",
    "dash.trades": "Operações",
    "dash.kicker": "Terminal de negociação",
    "dash.title": "Opere nos cinco mercados a partir do terminal",
    "dash.text": "Acompanhe cotações em tempo real, abra e feche posições e siga o gráfico de cada ativo em Crypto, Stocks, Forex, Commodities e Indices.",
    "dash.openTerminal": "Abrir terminal",
    "dash.qrTitle": "Terminal Web",
    "dash.qrHint": "Digitalize para abrir no seu telefone",
    "trade.marketOrder": "Ordem a mercado",
    "trade.volume": "Volume",
    "trade.advanced": "Avançado · TP / SL",
    "trade.tp": "Take profit",
    "trade.sl": "Stop loss",
    "trade.margin": "Margem",
    "trade.free": "Livre",
    "trade.buyDone": "Compra executada",
    "trade.sellDone": "Venda executada",
    "trade.closed": "Posição fechada",
    "demo.intro": "Abra uma conta de demonstração no MetaTrader para praticar sem risco. O terminal abre numa nova janela.",
    "demo.mt4Desc": "Plataforma clássica para CFDs e Forex.",
    "demo.mt5Desc": "Versão mais recente, com mais timeframes e ferramentas.",
    "demo.open": "Abrir",
    "demo.badge": "Conta demo",
    "info.cfdTitle": "O que é trading de CFDs",
    "info.cfdP1": "Um CFD (Contrato por Diferença) é um contrato em que se negocia a diferença de preço de um ativo entre a abertura e o fecho da posição, sem comprar o ativo em si. Se acredita que o preço vai subir, abre uma posição de compra (BUY); se acredita que vai descer, abre uma venda (SELL).",
    "info.cfdP2": "Como os CFDs usam alavancagem, apenas uma parte do valor da operação fica reservada como margem. Isso amplia tanto os lucros como as perdas, por isso é importante usar Take Profit e Stop Loss.",
    "info.crypto": "Cripto",
    "info.cryptoText": "Moedas digitais como Bitcoin e Ethereum. Mercado aberto 24/7 e com forte volatilidade.",
    "info.stocks": "Ações",
    "info.stocksText": "CFDs sobre empresas cotadas em bolsa, como Apple ou Tesla. Seguem o horário das bolsas.",
    "info.forex": "Forex",
    "info.forexText": "Troca de moedas em pares (EUR/USD, GBP/USD). O maior mercado do mundo em volume.",
    "info.commodities": "Commodities",
    "info.commoditiesText": "Matérias-primas como ouro, petróleo e gás natural, muito sensíveis a notícias globais.",
    "info.indices": "Índices",
    "info.indicesText": "Cestas de ações que representam um mercado inteiro, como o S&P 500 ou o DAX.",
    "info.termsTitle": "Termos que vai ver no terminal",
    "info.term1": "tamanho da posição.",
    "info.term2": "valor reservado da conta para manter a posição aberta.",
    "info.term3": "saldo somado ao lucro ou prejuízo das posições abertas.",
    "info.term4": "relação entre equity e margem usada; níveis baixos indicam risco.",
    "info.term5": "lucro ou prejuízo da operação.",
  },
  en: {
    "trade.close": "Close",
    "docs.type": "Document type",
    "docs.kind.id_card": "Identity document (ID)",
    "docs.kind.passport": "Passport",
    "docs.kind.address_proof": "Proof of address",
    "docs.kind.other": "Other",
    "docs.limit": "PDF, PNG or JPG · max 5 MB",
    "docs.tooLarge": "The file exceeds the 5 MB limit",
    "docs.pickFirst": "Choose a document first",
    "docs.sent": "Document sent — under review",
    "docs.mine": "My documents",
    "docs.empty": "You have not uploaded documents yet",
    "auth.overline": "Platform access",
    "auth.loginTitle": "Sign in to your account",
    "auth.loginSubtitle": "Global markets in a single terminal.",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.phone": "Phone",
    "auth.signIn": "Sign in",
    "auth.createAccount": "Create account",
    "auth.registerOverline": "New user",
    "auth.registerTitle": "Create account",
    "auth.registerSubtitle": "Registration requires an access code.",
    "auth.name": "Name",
    "auth.namePlaceholder": "Your name",
    "auth.newPassword": "Create password",
    "auth.passwordHint": "Minimum 6 characters",
    "auth.inviteCode": "Registration code",
    "auth.haveAccount": "Already have an account?",
    "auth.twofaOverline": "Two-step verification",
    "auth.twofaTitle": "Authentication code",
    "auth.twofaSubtitle": "Enter the 6-digit code from your authenticator app.",
    "auth.verify": "Verify",
    "auth.useRecovery": "Use a recovery code",
    "auth.useAuthenticator": "Use authenticator code",
    "auth.recoveryCode": "Recovery code",
    "auth.setupOverline": "Mandatory security",
    "auth.setupTitle": "Enable 2FA",
    "auth.setupSubtitle": "Administrative accounts require two-factor authentication.",
    "auth.tagline": "Trading for those who demand more",
    "auth.taglineSub": "Global markets. Professional tools",
    "auth.footer": "Five markets · Instant execution",
    "pager.prev": "Previous",
    "pager.next": "Next",
    "pager.page": "Page",
    "pager.records": "record(s)",
    "profile.personalInfo": "Personal information",
    "profile.firstName": "First name",
    "profile.lastName": "Last name",
    "profile.country": "Country of residence",
    "profile.city": "City",
    "profile.street": "Street",
    "profile.postalCode": "Postal code",
    "funds.balance": "Account balance",
    "funds.free": "Free margin",
    "funds.used": "Used margin",
    "funds.deposit": "Deposit",
    "funds.depositDesc": "Transfers to your account via BTC, USDT or PIX.",
    "funds.withdraw": "Withdraw",
    "funds.withdrawDesc": "Request a withdrawal to your registered account.",
    "deposit.title": "Deposit",
    "deposit.none": "No method available. Please contact support.",
    "deposit.pixKey": "PIX key",
    "deposit.wallet": "Wallet",
    "deposit.amount": "Amount (USD)",
    "deposit.reference": "Reference / transfer hash (optional)",
    "deposit.confirm": "Confirm deposit",
    "deposit.history": "Deposit history",
    "deposit.empty": "No deposits",
    "deposit.copied": "Copied",
    "deposit.registered": "Deposit registered — under review",
    "status.pending": "under review",
    "status.approved": "approved",
    "status.rejected": "rejected",
    "withdraw.accountName": "Name (e.g. My wallet)",
    "withdraw.bank": "Bank / BIC-SWIFT (optional)",
    "withdraw.empty": "No requests",
    "withdraw.sent": "Request sent — under review",
    "withdraw.accountAdded": "Receiving account added",
    "calendar.title": "Economic Calendar",
    "calendar.subtitle": "Macroeconomic events and real-time market news.",
    "calendar.events": "Calendar",
    "calendar.news": "News",
    "tools.title": "Market analysis tools",
    "tools.subtitle": "Technical indicators, overview, screener and heatmap.",
    "tools.symbols": "World markets",
    "tools.overview": "Market overview",
    "tools.screener": "Screener",
    "tools.heatmap": "Heatmap",
    "settings.subtitle": "Update your profile details and password.",
    "settings.profile": "Profile",
    "settings.name": "Name",
    "settings.email": "Email",
    "settings.phone": "Phone",
    "settings.saveProfile": "Save profile",
    "settings.security": "Security",
    "settings.currentPwd": "Current password",
    "settings.newPwd": "New password",
    "settings.confirmPwd": "Confirm",
    "settings.changePwd": "Change password",
    "settings.profileUpdated": "Profile updated",
    "settings.pwdChanged": "Password changed",
    "settings.pwdMismatch": "New passwords do not match",
    "dash.hello": "Hello",
    "dash.subtitle": "Overview of your account",
    "dash.balance": "Balance",
    "dash.invested": "Invested",
    "dash.positions": "Positions",
    "dash.trades": "Trades",
    "dash.kicker": "Trading terminal",
    "dash.title": "Trade the five markets from the terminal",
    "dash.text": "Follow live quotes, open and close positions and watch each asset's chart across Crypto, Stocks, Forex, Commodities and Indices.",
    "dash.openTerminal": "Open terminal",
    "dash.qrTitle": "Web Terminal",
    "dash.qrHint": "Scan to open on your phone",
    "trade.marketOrder": "Market order",
    "trade.volume": "Volume",
    "trade.advanced": "Advanced · TP / SL",
    "trade.tp": "Take profit",
    "trade.sl": "Stop loss",
    "trade.margin": "Margin",
    "trade.free": "Free",
    "trade.buyDone": "Buy executed",
    "trade.sellDone": "Sell executed",
    "trade.closed": "Position closed",
    "demo.intro": "Open a MetaTrader demo account to practise risk-free. The terminal opens in a new window.",
    "demo.mt4Desc": "Classic platform for CFDs and Forex.",
    "demo.mt5Desc": "Newer version with more timeframes and tools.",
    "demo.open": "Open",
    "demo.badge": "Demo account",
    "info.cfdTitle": "What is CFD trading",
    "info.cfdP1": "A CFD (Contract for Difference) is a contract where you trade the price difference of an asset between opening and closing the position, without owning the asset. If you believe the price will rise you open a buy (BUY); if you believe it will fall you open a sell (SELL).",
    "info.cfdP2": "Because CFDs use leverage, only part of the trade value is reserved as margin. This amplifies both profits and losses, so using Take Profit and Stop Loss matters.",
    "info.crypto": "Crypto",
    "info.cryptoText": "Digital currencies such as Bitcoin and Ethereum. Open 24/7 and highly volatile.",
    "info.stocks": "Stocks",
    "info.stocksText": "CFDs on listed companies such as Apple or Tesla. They follow exchange hours.",
    "info.forex": "Forex",
    "info.forexText": "Currency trading in pairs (EUR/USD, GBP/USD). The largest market by volume.",
    "info.commodities": "Commodities",
    "info.commoditiesText": "Raw materials such as gold, oil and natural gas, very sensitive to global news.",
    "info.indices": "Indices",
    "info.indicesText": "Baskets of stocks representing a whole market, such as the S&P 500 or DAX.",
    "info.termsTitle": "Terms you will see in the terminal",
    "info.term1": "position size.",
    "info.term2": "amount reserved from the account to keep the position open.",
    "info.term3": "balance plus the profit or loss of open positions.",
    "info.term4": "ratio between equity and used margin; low levels indicate risk.",
    "info.term5": "profit or loss of the trade.",
  },
  es: {
    "trade.close": "Cerrar",
    "docs.type": "Tipo de documento",
    "docs.kind.id_card": "Documento de identidad (DNI)",
    "docs.kind.passport": "Pasaporte",
    "docs.kind.address_proof": "Comprobante de domicilio",
    "docs.kind.other": "Otro",
    "docs.limit": "PDF, PNG o JPG · máximo 5 MB",
    "docs.tooLarge": "El archivo supera el límite de 5 MB",
    "docs.pickFirst": "Elija un documento primero",
    "docs.sent": "Documento enviado — en revisión",
    "docs.mine": "Mis documentos",
    "docs.empty": "Todavía no ha enviado documentos",
    "auth.overline": "Acceso a la plataforma",
    "auth.loginTitle": "Entrar en su cuenta",
    "auth.loginSubtitle": "Mercados globales en un solo terminal.",
    "auth.email": "Correo",
    "auth.password": "Contraseña",
    "auth.phone": "Teléfono",
    "auth.signIn": "Entrar",
    "auth.createAccount": "Crear cuenta",
    "auth.registerOverline": "Nuevo usuario",
    "auth.registerTitle": "Crear cuenta",
    "auth.registerSubtitle": "El registro requiere un código de acceso.",
    "auth.name": "Nombre",
    "auth.namePlaceholder": "Su nombre",
    "auth.newPassword": "Crear contraseña",
    "auth.passwordHint": "Mínimo 6 caracteres",
    "auth.inviteCode": "Código de registro",
    "auth.haveAccount": "¿Ya tiene cuenta?",
    "auth.twofaOverline": "Verificación en dos pasos",
    "auth.twofaTitle": "Código de autenticación",
    "auth.twofaSubtitle": "Introduzca el código de 6 dígitos de su aplicación de autenticación.",
    "auth.verify": "Verificar",
    "auth.useRecovery": "Usar código de recuperación",
    "auth.useAuthenticator": "Usar código del autenticador",
    "auth.recoveryCode": "Código de recuperación",
    "auth.setupOverline": "Seguridad obligatoria",
    "auth.setupTitle": "Activar 2FA",
    "auth.setupSubtitle": "Las cuentas administrativas exigen autenticación en dos pasos.",
    "auth.tagline": "Trading para quien exige más",
    "auth.taglineSub": "Mercados globales. Herramientas profesionales",
    "auth.footer": "Cinco mercados · Ejecución instantánea",
    "pager.prev": "Anterior",
    "pager.next": "Siguiente",
    "pager.page": "Página",
    "pager.records": "registro(s)",
    "profile.personalInfo": "Información personal",
    "profile.firstName": "Nombre",
    "profile.lastName": "Apellido",
    "profile.country": "País de residencia",
    "profile.city": "Ciudad",
    "profile.street": "Calle",
    "profile.postalCode": "Código postal",
    "funds.balance": "Saldo de la cuenta",
    "funds.free": "Margen libre",
    "funds.used": "Margen usado",
    "funds.deposit": "Depósito",
    "funds.depositDesc": "Transferencias a su cuenta por BTC, USDT o PIX.",
    "funds.withdraw": "Retirar",
    "funds.withdrawDesc": "Solicite un retiro a la cuenta registrada.",
    "deposit.title": "Depósito",
    "deposit.none": "Ningún método disponible. Contacte al soporte.",
    "deposit.pixKey": "Clave PIX",
    "deposit.wallet": "Cartera",
    "deposit.amount": "Importe (USD)",
    "deposit.reference": "Referencia / hash de la transferencia (opcional)",
    "deposit.confirm": "Confirmar depósito",
    "deposit.history": "Historial de depósitos",
    "deposit.empty": "Sin depósitos",
    "deposit.copied": "Copiado",
    "deposit.registered": "Depósito registrado — en revisión",
    "status.pending": "en revisión",
    "status.approved": "aprobado",
    "status.rejected": "rechazado",
    "withdraw.accountName": "Nombre (ej.: Mi cartera)",
    "withdraw.bank": "Banco / BIC-SWIFT (opcional)",
    "withdraw.empty": "Sin solicitudes",
    "withdraw.sent": "Solicitud enviada — en revisión",
    "withdraw.accountAdded": "Cuenta de cobro agregada",
    "calendar.title": "Calendario económico",
    "calendar.subtitle": "Eventos macroeconómicos y noticias de los mercados en tiempo real.",
    "calendar.events": "Calendario",
    "calendar.news": "Noticias",
    "tools.title": "Herramientas de análisis de mercado",
    "tools.subtitle": "Indicadores técnicos, visión general, rastreador y mapa de calor.",
    "tools.symbols": "Mercados mundiales",
    "tools.overview": "Visión de mercado",
    "tools.screener": "Rastreador",
    "tools.heatmap": "Mapa de calor",
    "settings.subtitle": "Actualice sus datos de perfil y su contraseña.",
    "settings.profile": "Perfil",
    "settings.name": "Nombre",
    "settings.email": "Correo",
    "settings.phone": "Teléfono",
    "settings.saveProfile": "Guardar perfil",
    "settings.security": "Seguridad",
    "settings.currentPwd": "Contraseña actual",
    "settings.newPwd": "Nueva contraseña",
    "settings.confirmPwd": "Confirmar",
    "settings.changePwd": "Cambiar contraseña",
    "settings.profileUpdated": "Perfil actualizado",
    "settings.pwdChanged": "Contraseña cambiada",
    "settings.pwdMismatch": "Las nuevas contraseñas no coinciden",
    "dash.hello": "Hola",
    "dash.subtitle": "Resumen de su cuenta",
    "dash.balance": "Saldo",
    "dash.invested": "Invertido",
    "dash.positions": "Posiciones",
    "dash.trades": "Operaciones",
    "dash.kicker": "Terminal de trading",
    "dash.title": "Opere en los cinco mercados desde el terminal",
    "dash.text": "Siga cotizaciones en tiempo real, abra y cierre posiciones y vea el gráfico de cada activo en Crypto, Stocks, Forex, Commodities e Índices.",
    "dash.openTerminal": "Abrir terminal",
    "dash.qrTitle": "Terminal Web",
    "dash.qrHint": "Escanee para abrir en su teléfono",
    "trade.marketOrder": "Orden a mercado",
    "trade.volume": "Volumen",
    "trade.advanced": "Avanzado · TP / SL",
    "trade.tp": "Take profit",
    "trade.sl": "Stop loss",
    "trade.margin": "Margen",
    "trade.free": "Libre",
    "trade.buyDone": "Compra ejecutada",
    "trade.sellDone": "Venta ejecutada",
    "trade.closed": "Posición cerrada",
    "demo.intro": "Abra una cuenta demo en MetaTrader para practicar sin riesgo. El terminal se abre en una nueva ventana.",
    "demo.mt4Desc": "Plataforma clásica para CFDs y Forex.",
    "demo.mt5Desc": "Versión más reciente, con más marcos temporales y herramientas.",
    "demo.open": "Abrir",
    "demo.badge": "Cuenta demo",
    "info.cfdTitle": "Qué es el trading de CFDs",
    "info.cfdP1": "Un CFD (Contrato por Diferencia) es un contrato en el que se negocia la diferencia de precio de un activo entre la apertura y el cierre de la posición, sin comprar el activo. Si cree que el precio subirá, abre una compra (BUY); si cree que bajará, abre una venta (SELL).",
    "info.cfdP2": "Como los CFDs usan apalancamiento, solo una parte del valor de la operación queda reservada como margen. Esto amplifica las ganancias y las pérdidas, por eso conviene usar Take Profit y Stop Loss.",
    "info.crypto": "Cripto",
    "info.cryptoText": "Monedas digitales como Bitcoin y Ethereum. Mercado abierto 24/7 y muy volátil.",
    "info.stocks": "Acciones",
    "info.stocksText": "CFDs sobre empresas cotizadas como Apple o Tesla. Siguen el horario de las bolsas.",
    "info.forex": "Forex",
    "info.forexText": "Cambio de divisas en pares (EUR/USD, GBP/USD). El mayor mercado por volumen.",
    "info.commodities": "Materias primas",
    "info.commoditiesText": "Materias primas como oro, petróleo y gas natural, muy sensibles a noticias globales.",
    "info.indices": "Índices",
    "info.indicesText": "Cestas de acciones que representan todo un mercado, como el S&P 500 o el DAX.",
    "info.termsTitle": "Términos que verá en el terminal",
    "info.term1": "tamaño de la posición.",
    "info.term2": "importe reservado de la cuenta para mantener la posición abierta.",
    "info.term3": "saldo más el beneficio o pérdida de las posiciones abiertas.",
    "info.term4": "relación entre equity y margen usado; niveles bajos indican riesgo.",
    "info.term5": "beneficio o pérdida de la operación.",
  },
  fr: {
    "trade.close": "Fermer",
    "docs.type": "Type de document",
    "docs.kind.id_card": "Pièce d'identité (carte)",
    "docs.kind.passport": "Passeport",
    "docs.kind.address_proof": "Justificatif de domicile",
    "docs.kind.other": "Autre",
    "docs.limit": "PDF, PNG ou JPG · 5 Mo maximum",
    "docs.tooLarge": "Le fichier dépasse la limite de 5 Mo",
    "docs.pickFirst": "Choisissez d'abord un document",
    "docs.sent": "Document envoyé — en cours d'examen",
    "docs.mine": "Mes documents",
    "docs.empty": "Vous n'avez encore envoyé aucun document",
    "auth.overline": "Accès à la plateforme",
    "auth.loginTitle": "Connexion à votre compte",
    "auth.loginSubtitle": "Les marchés mondiaux dans un seul terminal.",
    "auth.email": "E-mail",
    "auth.password": "Mot de passe",
    "auth.phone": "Téléphone",
    "auth.signIn": "Se connecter",
    "auth.createAccount": "Créer un compte",
    "auth.registerOverline": "Nouvel utilisateur",
    "auth.registerTitle": "Créer un compte",
    "auth.registerSubtitle": "L'inscription nécessite un code d'accès.",
    "auth.name": "Nom",
    "auth.namePlaceholder": "Votre nom",
    "auth.newPassword": "Créer un mot de passe",
    "auth.passwordHint": "6 caractères minimum",
    "auth.inviteCode": "Code d'inscription",
    "auth.haveAccount": "Vous avez déjà un compte ?",
    "auth.twofaOverline": "Vérification en deux étapes",
    "auth.twofaTitle": "Code d’authentification",
    "auth.twofaSubtitle": "Saisissez le code à 6 chiffres de votre application d’authentification.",
    "auth.verify": "Vérifier",
    "auth.useRecovery": "Utiliser un code de récupération",
    "auth.useAuthenticator": "Utiliser le code de l’application",
    "auth.recoveryCode": "Code de récupération",
    "auth.setupOverline": "Sécurité obligatoire",
    "auth.setupTitle": "Activer la 2FA",
    "auth.setupSubtitle": "Les comptes administratifs exigent une authentification à deux facteurs.",
    "auth.tagline": "Le trading pour les plus exigeants",
    "auth.taglineSub": "Marchés mondiaux. Outils professionnels",
    "auth.footer": "Cinq marchés · Exécution instantanée",
    "pager.prev": "Précédent",
    "pager.next": "Suivant",
    "pager.page": "Page",
    "pager.records": "enregistrement(s)",
    "profile.personalInfo": "Informations personnelles",
    "profile.firstName": "Prénom",
    "profile.lastName": "Nom",
    "profile.country": "Pays de résidence",
    "profile.city": "Ville",
    "profile.street": "Rue",
    "profile.postalCode": "Code postal",
    "funds.balance": "Solde du compte",
    "funds.free": "Marge libre",
    "funds.used": "Marge utilisée",
    "funds.deposit": "Dépôt",
    "funds.depositDesc": "Transferts vers votre compte par BTC, USDT ou PIX.",
    "funds.withdraw": "Retirer",
    "funds.withdrawDesc": "Demandez un retrait vers le compte enregistré.",
    "deposit.title": "Dépôt",
    "deposit.none": "Aucune méthode disponible. Contactez le support.",
    "deposit.pixKey": "Clé PIX",
    "deposit.wallet": "Portefeuille",
    "deposit.amount": "Montant (USD)",
    "deposit.reference": "Référence / hash du transfert (facultatif)",
    "deposit.confirm": "Confirmer le dépôt",
    "deposit.history": "Historique des dépôts",
    "deposit.empty": "Aucun dépôt",
    "deposit.copied": "Copié",
    "deposit.registered": "Dépôt enregistré — en cours d'examen",
    "status.pending": "en cours d'examen",
    "status.approved": "approuvé",
    "status.rejected": "refusé",
    "withdraw.accountName": "Nom (ex. : Mon portefeuille)",
    "withdraw.bank": "Banque / BIC-SWIFT (facultatif)",
    "withdraw.empty": "Aucune demande",
    "withdraw.sent": "Demande envoyée — en cours d'examen",
    "withdraw.accountAdded": "Compte de réception ajouté",
    "calendar.title": "Calendrier économique",
    "calendar.subtitle": "Événements macroéconomiques et actualités des marchés en temps réel.",
    "calendar.events": "Calendrier",
    "calendar.news": "Actualités",
    "tools.title": "Outils d'analyse de marché",
    "tools.subtitle": "Indicateurs techniques, vue d'ensemble, screener et carte de chaleur.",
    "tools.symbols": "Marchés mondiaux",
    "tools.overview": "Vue de marché",
    "tools.screener": "Screener",
    "tools.heatmap": "Carte de chaleur",
    "settings.subtitle": "Mettez à jour vos informations de profil et votre mot de passe.",
    "settings.profile": "Profil",
    "settings.name": "Nom",
    "settings.email": "E-mail",
    "settings.phone": "Téléphone",
    "settings.saveProfile": "Enregistrer le profil",
    "settings.security": "Sécurité",
    "settings.currentPwd": "Mot de passe actuel",
    "settings.newPwd": "Nouveau mot de passe",
    "settings.confirmPwd": "Confirmer",
    "settings.changePwd": "Changer le mot de passe",
    "settings.profileUpdated": "Profil mis à jour",
    "settings.pwdChanged": "Mot de passe modifié",
    "settings.pwdMismatch": "Les nouveaux mots de passe ne correspondent pas",
    "dash.hello": "Bonjour",
    "dash.subtitle": "Vue d'ensemble de votre compte",
    "dash.balance": "Solde",
    "dash.invested": "Investi",
    "dash.positions": "Positions",
    "dash.trades": "Opérations",
    "dash.kicker": "Terminal de trading",
    "dash.title": "Tradez les cinq marchés depuis le terminal",
    "dash.text": "Suivez les cotations en direct, ouvrez et fermez des positions et consultez le graphique de chaque actif en Crypto, Actions, Forex, Matières premières et Indices.",
    "dash.openTerminal": "Ouvrir le terminal",
    "dash.qrTitle": "Terminal Web",
    "dash.qrHint": "Scannez pour ouvrir sur votre téléphone",
    "trade.marketOrder": "Ordre au marché",
    "trade.volume": "Volume",
    "trade.advanced": "Avancé · TP / SL",
    "trade.tp": "Take profit",
    "trade.sl": "Stop loss",
    "trade.margin": "Marge",
    "trade.free": "Libre",
    "trade.buyDone": "Achat exécuté",
    "trade.sellDone": "Vente exécutée",
    "trade.closed": "Position fermée",
    "demo.intro": "Ouvrez un compte démo MetaTrader pour vous entraîner sans risque. Le terminal s'ouvre dans une nouvelle fenêtre.",
    "demo.mt4Desc": "Plateforme classique pour CFD et Forex.",
    "demo.mt5Desc": "Version plus récente, avec plus d'unités de temps et d'outils.",
    "demo.open": "Ouvrir",
    "demo.badge": "Compte démo",
    "info.cfdTitle": "Qu'est-ce que le trading de CFD",
    "info.cfdP1": "Un CFD (Contrat sur la Différence) est un contrat où l'on négocie la différence de prix d'un actif entre l'ouverture et la clôture de la position, sans acheter l'actif. Si vous pensez que le prix va monter, vous ouvrez un achat (BUY) ; s'il va baisser, une vente (SELL).",
    "info.cfdP2": "Comme les CFD utilisent l'effet de levier, seule une partie de la valeur de l'opération est réservée en marge. Cela amplifie les gains comme les pertes : utilisez Take Profit et Stop Loss.",
    "info.crypto": "Crypto",
    "info.cryptoText": "Monnaies numériques comme Bitcoin et Ethereum. Marché ouvert 24/7 et très volatil.",
    "info.stocks": "Actions",
    "info.stocksText": "CFD sur des sociétés cotées comme Apple ou Tesla. Ils suivent les horaires des bourses.",
    "info.forex": "Forex",
    "info.forexText": "Échange de devises par paires (EUR/USD, GBP/USD). Le plus grand marché en volume.",
    "info.commodities": "Matières premières",
    "info.commoditiesText": "Or, pétrole et gaz naturel, très sensibles à l'actualité mondiale.",
    "info.indices": "Indices",
    "info.indicesText": "Paniers d'actions représentant un marché entier, comme le S&P 500 ou le DAX.",
    "info.termsTitle": "Termes visibles dans le terminal",
    "info.term1": "taille de la position.",
    "info.term2": "montant réservé du compte pour maintenir la position ouverte.",
    "info.term3": "solde plus le profit ou la perte des positions ouvertes.",
    "info.term4": "rapport entre capitaux propres et marge utilisée ; un niveau bas indique un risque.",
    "info.term5": "profit ou perte de l'opération.",
  },
  it: {
    "trade.close": "Chiudi",
    "docs.type": "Tipo di documento",
    "docs.kind.id_card": "Documento d'identità (carta)",
    "docs.kind.passport": "Passaporto",
    "docs.kind.address_proof": "Prova di residenza",
    "docs.kind.other": "Altro",
    "docs.limit": "PDF, PNG o JPG · massimo 5 MB",
    "docs.tooLarge": "Il file supera il limite di 5 MB",
    "docs.pickFirst": "Scegli prima un documento",
    "docs.sent": "Documento inviato — in revisione",
    "docs.mine": "I miei documenti",
    "docs.empty": "Non hai ancora inviato documenti",
    "auth.overline": "Accesso alla piattaforma",
    "auth.loginTitle": "Accedi al tuo conto",
    "auth.loginSubtitle": "Mercati globali in un unico terminale.",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.phone": "Telefono",
    "auth.signIn": "Accedi",
    "auth.createAccount": "Crea conto",
    "auth.registerOverline": "Nuovo utente",
    "auth.registerTitle": "Crea conto",
    "auth.registerSubtitle": "La registrazione richiede un codice d'accesso.",
    "auth.name": "Nome",
    "auth.namePlaceholder": "Il tuo nome",
    "auth.newPassword": "Crea password",
    "auth.passwordHint": "Minimo 6 caratteri",
    "auth.inviteCode": "Codice di registrazione",
    "auth.haveAccount": "Hai già un conto?",
    "auth.twofaOverline": "Verifica in due passaggi",
    "auth.twofaTitle": "Codice di autenticazione",
    "auth.twofaSubtitle": "Inserisci il codice a 6 cifre dell'app di autenticazione.",
    "auth.verify": "Verifica",
    "auth.useRecovery": "Usa un codice di recupero",
    "auth.useAuthenticator": "Usa il codice dell'app",
    "auth.recoveryCode": "Codice di recupero",
    "auth.setupOverline": "Sicurezza obbligatoria",
    "auth.setupTitle": "Attiva 2FA",
    "auth.setupSubtitle": "I conti amministrativi richiedono autenticazione a due fattori.",
    "auth.tagline": "Trading per chi pretende di più",
    "auth.taglineSub": "Mercati globali. Strumenti professionali",
    "auth.footer": "Cinque mercati · Esecuzione istantanea",
    "pager.prev": "Precedente",
    "pager.next": "Successivo",
    "pager.page": "Pagina",
    "pager.records": "record",
    "profile.personalInfo": "Informazioni personali",
    "profile.firstName": "Nome",
    "profile.lastName": "Cognome",
    "profile.country": "Paese di residenza",
    "profile.city": "Città",
    "profile.street": "Via",
    "profile.postalCode": "Codice postale",
    "funds.balance": "Saldo del conto",
    "funds.free": "Margine libero",
    "funds.used": "Margine usato",
    "funds.deposit": "Deposito",
    "funds.depositDesc": "Trasferimenti sul tuo conto tramite BTC, USDT o PIX.",
    "funds.withdraw": "Prelevare",
    "funds.withdrawDesc": "Richiedi un prelievo sul conto registrato.",
    "deposit.title": "Deposito",
    "deposit.none": "Nessun metodo disponibile. Contatta il supporto.",
    "deposit.pixKey": "Chiave PIX",
    "deposit.wallet": "Portafoglio",
    "deposit.amount": "Importo (USD)",
    "deposit.reference": "Riferimento / hash del trasferimento (opzionale)",
    "deposit.confirm": "Conferma deposito",
    "deposit.history": "Storico depositi",
    "deposit.empty": "Nessun deposito",
    "deposit.copied": "Copiato",
    "deposit.registered": "Deposito registrato — in revisione",
    "status.pending": "in revisione",
    "status.approved": "approvato",
    "status.rejected": "rifiutato",
    "withdraw.accountName": "Nome (es.: Il mio portafoglio)",
    "withdraw.bank": "Banca / BIC-SWIFT (opzionale)",
    "withdraw.empty": "Nessuna richiesta",
    "withdraw.sent": "Richiesta inviata — in revisione",
    "withdraw.accountAdded": "Conto di ricezione aggiunto",
    "calendar.title": "Calendario economico",
    "calendar.subtitle": "Eventi macroeconomici e notizie di mercato in tempo reale.",
    "calendar.events": "Calendario",
    "calendar.news": "Notizie",
    "tools.title": "Strumenti di analisi di mercato",
    "tools.subtitle": "Indicatori tecnici, panoramica, screener e mappa di calore.",
    "tools.symbols": "Mercati mondiali",
    "tools.overview": "Panoramica di mercato",
    "tools.screener": "Screener",
    "tools.heatmap": "Mappa di calore",
    "settings.subtitle": "Aggiorna i dati del profilo e la password.",
    "settings.profile": "Profilo",
    "settings.name": "Nome",
    "settings.email": "Email",
    "settings.phone": "Telefono",
    "settings.saveProfile": "Salva profilo",
    "settings.security": "Sicurezza",
    "settings.currentPwd": "Password attuale",
    "settings.newPwd": "Nuova password",
    "settings.confirmPwd": "Conferma",
    "settings.changePwd": "Cambia password",
    "settings.profileUpdated": "Profilo aggiornato",
    "settings.pwdChanged": "Password cambiata",
    "settings.pwdMismatch": "Le nuove password non coincidono",
    "dash.hello": "Ciao",
    "dash.subtitle": "Panoramica del tuo conto",
    "dash.balance": "Saldo",
    "dash.invested": "Investito",
    "dash.positions": "Posizioni",
    "dash.trades": "Operazioni",
    "dash.kicker": "Terminale di trading",
    "dash.title": "Opera sui cinque mercati dal terminale",
    "dash.text": "Segui le quotazioni in tempo reale, apri e chiudi posizioni e osserva il grafico di ogni asset in Crypto, Azioni, Forex, Materie prime e Indici.",
    "dash.openTerminal": "Apri terminale",
    "dash.qrTitle": "Terminale Web",
    "dash.qrHint": "Scansiona per aprire sul telefono",
    "trade.marketOrder": "Ordine a mercato",
    "trade.volume": "Volume",
    "trade.advanced": "Avanzato · TP / SL",
    "trade.tp": "Take profit",
    "trade.sl": "Stop loss",
    "trade.margin": "Margine",
    "trade.free": "Libero",
    "trade.buyDone": "Acquisto eseguito",
    "trade.sellDone": "Vendita eseguita",
    "trade.closed": "Posizione chiusa",
    "demo.intro": "Apri un conto demo MetaTrader per esercitarti senza rischi. Il terminale si apre in una nuova finestra.",
    "demo.mt4Desc": "Piattaforma classica per CFD e Forex.",
    "demo.mt5Desc": "Versione più recente, con più timeframe e strumenti.",
    "demo.open": "Apri",
    "demo.badge": "Conto demo",
    "info.cfdTitle": "Che cos'è il trading di CFD",
    "info.cfdP1": "Un CFD (Contratto per Differenza) è un contratto in cui si negozia la differenza di prezzo di un asset tra apertura e chiusura della posizione, senza acquistare l'asset. Se pensi che il prezzo salirà apri un acquisto (BUY); se pensi che scenderà apri una vendita (SELL).",
    "info.cfdP2": "Poiché i CFD usano la leva, solo una parte del valore dell'operazione viene riservata come margine. Questo amplifica profitti e perdite, quindi è importante usare Take Profit e Stop Loss.",
    "info.crypto": "Cripto",
    "info.cryptoText": "Valute digitali come Bitcoin ed Ethereum. Mercato aperto 24/7 e molto volatile.",
    "info.stocks": "Azioni",
    "info.stocksText": "CFD su società quotate come Apple o Tesla. Seguono gli orari delle borse.",
    "info.forex": "Forex",
    "info.forexText": "Scambio di valute in coppie (EUR/USD, GBP/USD). Il mercato più grande per volume.",
    "info.commodities": "Materie prime",
    "info.commoditiesText": "Oro, petrolio e gas naturale, molto sensibili alle notizie globali.",
    "info.indices": "Indici",
    "info.indicesText": "Panieri di azioni che rappresentano un intero mercato, come S&P 500 o DAX.",
    "info.termsTitle": "Termini che vedrai nel terminale",
    "info.term1": "dimensione della posizione.",
    "info.term2": "importo riservato dal conto per mantenere aperta la posizione.",
    "info.term3": "saldo più profitto o perdita delle posizioni aperte.",
    "info.term4": "rapporto tra equity e margine usato; livelli bassi indicano rischio.",
    "info.term5": "profitto o perdita dell'operazione.",
  },
};
